export interface uploadToStorageModel{
    file: File, 
    category: ObjectStorageFileCategory,
    type?: ObjectStorageFileType
}
export interface uploadResponseModel{
    url: string, 
    fileName: string,
    fileExtension: string
}

export enum ObjectStorageFileCategory
{
    Country = 0,
    City = 1,
    User = 2,
    Achievement = 3,
    Marathon = 4,
    RunEvent = 5,
    MarathonDistance = 6,
    RunEventDistance = 7,
    DiscoveryPointImage = 8,
    DiscoveryPointObject = 9,
    UserProfile = 10,
    RunningClub = 11,
    ReportActivity = 12,
    StoryBanner = 13,
    StoryBadge = 14,
    StoryChapterBanner = 15,
    StoryChapterMedia = 16,
    EncyclopediaItem = 17,
    ScrapedEvent = 18,
    EventRecord = 19,
    AdvanceShare = 20,
    SportBrand = 21,
    BrandGear = 22,
    TemplateCover = 23,
    TemplatePack = 24,
    EnergyHub = 25,
    EnergyHubReceipt = 26,
}


export enum ObjectStorageFileType
{
    Image = 0,
    Video = 1,
    Sound = 2,
    Other = 3
}

export enum ExtensionTypeEnum {
    Jpg = 1,
    Png = 2,
    Svg = 3
}

export const ExtensionTypeList = [
    {value: 1, label: "Jpg"},
    {value: 2, label: "Png"},
    {value: 3, label: "Svg"},
];